import React from "react";

const Product = () => (
  <svg
    width="29"
    height="30"
    viewBox="0 0 29 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.6666 12.3332L27.9999 6.99984M14.6666 12.3332V28.3332M14.6666 12.3332L1.33325 6.99984M27.9999 6.99984V22.9998L14.6666 28.3332M27.9999 6.99984L14.6666 1.6665L1.33325 6.99984M14.6666 28.3332L1.33325 22.9998V6.99984"
      stroke="#252828"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

Product.propTypes = {};

Product.defaultProps = {};

export default Product;
